import useIsLihpHome from 'bundles/collections-carousel/utils/useIsLihp';
import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export const useIsPathwaysForAllEnabled = (makeImpression: boolean = false) => {
  const isLihpHome = useIsLihpHome();
  if (!isLihpHome) {
    return false;
  }
  return makeImpression
    ? GrowthDiscoveryEpicClient.get('enablePathwaysForAll')
    : GrowthDiscoveryEpicClient.preview('enablePathwaysForAll');
};

export const useIsPathwaysForAllEnabledWithImpression = () => useIsPathwaysForAllEnabled(true);
